import styles from "./branding.module.css";
import Image from "next/image";
import Link from "next/link";

export function TopBarBranding() {
    return (
        <div className={styles.topBarBranding}>
            <Link href="/" className={styles["companyLogo"]}>
                <Image
                    priority
                    src="/assets/images/company-logo.svg"
                    height={55}
                    width={79}
                    alt="Ultra-X, Inc. Logo Image"
                />
            </Link>
            <Link href="/" className={styles["companyName"]}>
                <Image
                    priority
                    src="/assets/images/company-name.svg"
                    height={12}
                    width={113}
                    alt="Ultra-X, Inc. Name Image"
                />
            </Link>
            <div className={styles["companySlogan"]}>
                PROFESSIONAL DIAGNOSTIC TOOLS
            </div>
        </div>
    )
}

export function FooterBranding() {
    return (
        <div className={styles.footerBranding}>
            <Image
                src="/assets/images/footer-branding.svg"
                height={20}
                width={205}
                alt="Ultra-X, Inc. Logo Image"
            />
        </div>
    )
}
